import React, { Suspense } from "react";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";
import StripeIntegration from "../routes/payments/components/stripe-integration";
import ThankyouPage from "../routes/payments/components/thank-you-page";
import Error from "./../routes/404";
import Loader from "./Loader";
// const Payments = React.lazy(() => import("../routes/payments/payments"));
const NewPayments = React.lazy(() => import("../routes/payments/new-components/NewPayments"));
const Payment = React.lazy(() => import("../routes/payments/payment"));
const PaymentConfirmation = React.lazy(() => import("../routes/payments/payment-confirmation"));
// const PaymentMethod = React.lazy(() => import('./../routes/payments/payment-tabs/add-payments'));
export default function Routes() {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/" component={Payment}></Route>
          <Route exact path="/payment" component={Payment}></Route>
          <Route exact path="/payments" component={NewPayments}></Route>
          <Route exact path="/register-status" component={ThankyouPage}></Route>
          <Route exact path="/payment-confirmation" component={PaymentConfirmation}></Route>
          <Route exact path="/stripe-integration" component={StripeIntegration}></Route>
          <Route exact path="/payments/intel" component={NewPayments}></Route>
          <Route exact path="/payments/source-atlas" component={NewPayments}></Route>
          <Route exact path="/payments/sanctions-screener" component={NewPayments}></Route>
          <Route exact path="/payments/trade-reference" component={NewPayments}></Route>
          <Route exact path="/payments/product-master" component={NewPayments}></Route>
          <Route exact path="/payments/landed-cost" component={NewPayments}></Route>
          <Route exact path="/payments/hs-classifier" component={NewPayments}></Route>
          <Route path={"*"} render={() => <Redirect to="/payments/intel" />} />
          <Route exact path="/404" component={Error}></Route>
          <Route component={Error} />
        </Switch>
      </Suspense>
    </Router>
  );
}
